// Software built by  Adeweb Developer Africa
// portfolio website: https://adeweb-developer.vercel.app
// whatsApp Message: https://wa.me/23407043455416
// I am open for your software development gig, thank you 



import { useState, useEffect } from "react";
import { auth, googleProvider } from "../../firebase";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import NameIcon from "../../assets/UserIcon.svg";
import UserOne from "../../assets/OnboardingCards/IMG_7252.JPG";
import UserTwo from "../../assets/OnboardingCards/IMG_7250.JPG";
import UserThree from "../../assets/OnboardingCards/IMG_7255.JPG";
import Dislikee from "../../assets/BottomNavBar/cancelLike.svg";
import "./Login.css";
import IkoroduLogo from "../../assets/OnboardingCards/Ikorodu-Dating-Logo.svg";
import FirstHook from "../../assets/IMG_2166.JPG";
import FirstHooks from "../../assets/IMG_2173.JPG";
import FirstHookd from "../../assets/IMG_2167.JPG";
import FirstHookf from "../../assets/IMG_2169.JPG";
import FirstHookh from "../../assets/IMG_2170.JPG";


import { FiZap, FiUserCheck, FiMapPin, FiShield } from "react-icons/fi";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [leftBar, setLeftBar] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
      };
  
      window.addEventListener("resize", handleResize);
  
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

  const handleEmailLogin = async (e) => {
    e.preventDefault();

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/");
    } catch (error) {
      setError(error.message);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
      navigate("/");
    } catch (error) {
      setError(error.message);
    }
  };

  const closeLeftModal = () => {
    setLeftBar(false);
  };

  return (
    <div className="login-container">
      <div className="onboardingBackBTN">
        <div className="authTextBox">
          <img style={{ width: 44 }} src={IkoroduLogo} alt="back button" />
          <h2 className="authText">Ikorodu Dating Site</h2>
        </div>

        <div></div>
      </div>

      <div className="signUpTop">
        <div className="signUpTopH">
          <h2>Login Back</h2>
          <p style={{ fontSize: 10, color: "#00000080" }}>
            Hi, Welcome back to your dating journey, i can see you are already
            making some moves
          </p>
        </div>

        <div className="userOnlineHolder">
          <div className="usersOnline">
            <img className="usersOnline" src={UserOne} alt="user online" />
          </div>
          <div className="usersOnline">
            <img className="usersOnline" src={UserTwo} alt="user online" />
          </div>
          <div className="usersOnline">
            <img className="usersOnline" src={UserThree} alt="user online" />
          </div>
        </div>
      </div>
      {error && <p>{error}</p>}
      <form className="login-form" onSubmit={handleEmailLogin}>
        <div className="signMeUp">
          <p className="signUp-info">Email</p>
        </div>
        <div className="signUpHolder">
          <img src={NameIcon} alt="back button" />

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="signMeUp">
          <p className="signUp-info">Password</p>
        </div>
        <div className="signUpHolder">
          <img src={NameIcon} alt="back button" />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button className="submit-Btn" type="submit">
          Login your Account
        </button>
        <div className="orDesign">
          -------- or you don't have an account? ---------
        </div>


        <button onClick={() => navigate("/signup")} className="faed">
          {" "}
          Please{" "}
          <span style={{ color: "#e91e63", fontSize: '17px', fontWeight: '600' }}>Sign up here</span>{" "}
        </button>


        <div
                style={{
                  width: "95%",
                  marginTop: "5%",
                }}
                className="sectionfront"
              >
                <div className="oldtext">
                  <h1>No Games. Just Connections.</h1>
      
                  <p>
                    Tired of the endless "what are we?" talk? We get it. Sometimes you
                    just want to skip the small talk and find someone who is on the
                    exact same page as you.
                  </p>
      
                  <div className="benefits-grid">
                    <div className="benefit-item">
                      <FiZap className="benefit-icon" />
                      <div className="benefit-text">
                        <h3>Zero Pressure</h3>
                        <p>
                          This is a judgment-free zone. State your intentions upfront
                          and find others doing the same.
                        </p>
                      </div>
                    </div>
      
                    <div className="benefit-item">
                      <FiUserCheck className="benefit-icon" />
                      <div className="benefit-text">
                        <h3>Verified Profiles</h3>
                        <p>
                          We prioritize real people. Our verification process ensures
                          who you see is who you meet.
                        </p>
                      </div>
                    </div>
      
                    <div className="benefit-item">
                      <FiMapPin className="benefit-icon" />
                      <div className="benefit-text">
                        <h3>Local & Ready</h3>
                        <p>
                          Find active members in Ikorodu who aren't looking to waste
                          time.
                        </p>
                      </div>
                    </div>
      
                    <div className="benefit-item">
                      <FiShield className="benefit-icon" />
                      <div className="benefit-text">
                        <h3>Total Privacy</h3>
                        <p>
                          Your business is yours. Encrypted messaging keeps your
                          conversations discreet.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="hooksBoxx">
                  <div
                    style={{
                      width: "100%",
                      marginTop: "0.2rem",
                      marginBottom: "1rem",
                    }}
                    className="bentoGrid"
                  >
                    {isMobile ? (
                      <div className="bentoTop">
                        <div className="bentotopone">
                          <div className="bentoChild">
                            <img
                              src={FirstHook}
                              alt="Casual Connection"
                              className="bentoImg"
                            />
                            <div className="bentoOverlay">
                              <h3>No Strings Attached</h3>
                            </div>
                          </div>
      
                          <div className="bentoChild">
                            <img
                              src={FirstHooks}
                              alt="Verified"
                              className="bentoImg"
                            />
                            <div className="bentoOverlay">
                              <h3>100% Verified</h3>
                            </div>
                          </div>
                        </div>
                        <div className="bentotoptwo">
                          <div className="bentoChild">
                            <img src={FirstHookd} alt="Local" className="bentoImg" />
                            <div className="bentoOverlay">
                              <h3>Right Near You</h3>
                            </div>
                          </div>
      
                          <div className="bentoChild">
                            <img
                              src={FirstHookf}
                              alt="Discreet"
                              className="bentoImg"
                            />
                            <div className="bentoOverlay">
                              <h3>Total Privacy</h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="bentoTop">
                        <div className="bentoChild">
                          <img
                            src={FirstHook}
                            alt="Casual Connection"
                            className="bentoImg"
                          />
                          <div className="bentoOverlay">
                            <h3>No Strings Attached</h3>
                          </div>
                        </div>
      
                        <div className="bentoChild">
                          <img src={FirstHooks} alt="Verified" className="bentoImg" />
                          <div className="bentoOverlay">
                            <h3>100% Verified</h3>
                          </div>
                        </div>
      
                        <div className="bentoChild">
                          <img src={FirstHookd} alt="Local" className="bentoImg" />
                          <div className="bentoOverlay">
                            <h3>Right Near You</h3>
                          </div>
                        </div>
      
                        <div className="bentoChild">
                          <img src={FirstHookf} alt="Discreet" className="bentoImg" />
                          <div className="bentoOverlay">
                            <h3>Total Privacy</h3>
                          </div>
                        </div>
                      </div>
                    )}
                    <div
                      style={{
                        overflow: "hidden",
                        height: "450px",
                      }}
                      className="bentoBottom"
                    >
                      <img src={FirstHookh} alt="Discreet" className="bentoImg" />
                      <div className="bentoOverlay">
                        <h3
                          style={{
                            fontWeight: "600",
                          }}
                        >
                          Find active members in Ikorodu ready to meet now.
                        </h3>
                        <p
                          style={{
                            color: "#ffffff90",
                            fontWeight: "500",
                          }}
                        >
                          Encrypted messaging to keep your business your business.
                        </p>
                        <p
                          style={{
                            color: "#ffffff90",
                            fontWeight: "500",
                          }}
                        >
                          We prioritize real people so who you see is who you meet.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
      </form>
    

      {leftBar && (
        <div className="leftScreenHolder">
          <div className="leftScreenHolderChild">
            <div className="leftPremiungap" style={{ gap: 60 }}>
              <div className="leftonboardingBackBTN">
                <div className="authTextBox">
                  <img
                    style={{ width: 50 }}
                    src={IkoroduLogo}
                    alt="back button"
                  />
                </div>

                <div></div>
              </div>

              <div className="menutextHolder">
                <div className="menutext">
                  <div> Your Likes</div>
                </div>
                <div className="menutext">
                  <div> Your Dislikes</div>
                </div>
                <div className="menutext">
                  <div>Your Matches</div>
                </div>
              </div>
            </div>

            <div className="leftPremiungap">
              <div className="premiumUserHolder">
                <div className="premiumUserHolderText">
                  <h4>Premium User</h4>

                  <p>
                    loremi khafi jkshfis kjahfliw akhflkw a.dwe ,a.efe weakw
                  </p>
                </div>
                <div className="premiumUserBox">
                  <div className="premiumUser"></div>
                  <div className="premiumUser"></div>
                  <div className="premiumUser"></div>
                  <div className="premiumUser"></div>
                  <div className="premiumUser"></div>
                  <div className="premiumUser"></div>
                </div>
              </div>

              <div
                style={{ background: "transparent", padding: 8 }}
                className="premiumUserHolder"
              >
                {/* <div className="premiumUserHolderText">
              <h4>
              Premium User
              </h4>

              <p>
                loremi khafi jkshfis kjahfliw akhflkw a.dwe ,a.efe weakw 
              </p>
              </div> */}

                <button className="premiumButton">Become a premium user</button>
              </div>
            </div>
          </div>
          <div className="leftScreenHolderChildother">
            <button onClick={closeLeftModal} className="nameStatususerr">
              <img style={{ width: 35 }} src={Dislikee} alt="" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
